import axios from "axios";
import qs from "qs";
import { Toast } from "vant";
import storage from "@/utils/storage";
import { clearAppTokens, ensureFreshAccessToken, forceRefreshAccessToken } from "@/utils/appAuth";

class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
    this.queue = {};
  }

  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        Authorization: storage.get("token"),
        UniqueId: storage.get("uniqueId"),
        "Content-Type": "application/x-www-form-urlencoded",
        // "Content-Type": "application/json",
      },
      timeout: 20 * 1000,
    };
    return config;
  }

  destroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      async (config) => {
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        this.queue[url] = true;

        if (!config.skipAuth && !config._retry && (storage.get("token") || storage.get("refreshToken"))) {
          await ensureFreshAccessToken();
          config.headers.Authorization = storage.get("token");
        }

        if (!config._retry) {
          config.method === "post"
            ? (config.data = qs.stringify({ ...config.data }))
            : (config.params = { ...config.params });
        }
          
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        this.destroy(url);
        const { data } = res;
        if (typeof data === "object") {
          // 自己处理
          // data = qs.stringify(data)
        }
        return data;
      },
      async (error) => {
        this.destroy(url);
        const originalRequest = error.config || {};
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          try {
            const token = await forceRefreshAccessToken();
            if (!token) throw new Error("No refresh credential is available");
            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers.Authorization = token;
            return instance(originalRequest);
          } catch (refreshError) {
            clearAppTokens();
          }
        }
        let errorInfo = error.response;
        if (!errorInfo) {
          //   console.log(JSON.parse(JSON.stringify(error)));
          //   const { request: { message, code }, config,} = JSON.parse(JSON.stringify(error));
          const { message, code, config } = JSON.parse(JSON.stringify(error));

          errorInfo = {
            message,
            code,
            request: { responseURL: config.url },
          };
          error.message = "请求超时";
          console.log("errorInfo", errorInfo);
        } else {
          switch (error.response.status) {
            case 400:
              error.message = "错误请求";
              break;
            case 401:
              error.message = "未授权，请重新登录";
              break;
            case 403:
              error.message = "拒绝访问";
              break;
            case 404:
              error.message = "请求错误,未找到该资源";
              window.location.href = "/NotFound";
              break;
            case 405:
              error.message = "请求方法未允许";
              break;
            case 408:
              error.message = "请求超时";
              break;
            case 500:
              error.message = "服务器端出错";
              break;
            case 501:
              error.message = "网络未实现";
              break;
            case 502:
              error.message = "网络错误";
              break;
            case 503:
              error.message = "服务不可用";
              break;
            case 504:
              error.message = "网络超时";
              break;
            case 505:
              error.message = "http版本不支持该请求";
              break;
            default:
              error.message = `连接错误${error.response.status}`;
          }
        }
        Toast(error.message);
        return Promise.reject(error);
      }
    );
  }

  request(options) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}
export default HttpRequest;
